// NOTE: These are the default values from Material-UI and _not_ based on the designs for this project.
// NOTE: This theme is specific to the CZ and TR market.
const values = {
  xs: 0,
  sm: 376,
  sml: 540,
  md: 743,
  mdl: 1024,
  lg: 1440,
  xl: 1536,
  xxl: 2000,
};

const breakpoints = {
  values: { ...values },
  maxContentWidth: "1440px",
  unit: "px",
  up: (measure: keyof typeof values): string => `@media (min-width:  ${values[measure]}px)`,
  down: (measure: keyof typeof values): string => `@media (max-width: ${values[measure]}px)`,
};

export default breakpoints;
